export default {
  getExams: '/examIntegration/getExamDetailsByCandidate',
  allExamForHallTicket: '/exam/allExamForHallTicket',
  getDetailsOfAnExam: '/exam/getExamById',
  getAnalysisOfAnExamForAStudent: '/examStudent/getExamAnalysisForAStudent',
  getExamsOfACriteria: '/exam/getExamsOfACriteria',
  getExamsAndSubjectAndQuestionDetails: '/newExam/getExamsAndSubjectAndQuestionDetails'
}
